import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SimplePresentation, SimplePresentationRunner} from "./presentations/SimplePresentationRunner";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Decadence} from "../Decadence";
import {DecadenceFSIntroPresentation} from "./presentations/DecadenceFSIntroPresentation";

class DoFreespinsZeroBetPresentation extends SimplePresentation {
    constructor() {
        super("FreespinsZeroBet", false);
    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(() => {
            SlotGame.apiPlugin.betHandler.zeroBet();
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Decadence.model.data.freespinsLeft-1);
        }, Decadence.model.freeSpinsPlayed == 0 ? ">" : ">0.3")
    }
}

export class DecadenceZeroBetIdleFlow implements FlowStatePresentation {

    private presentations:SimplePresentation[] = [
        new DecadenceFSIntroPresentation(),
        new DoFreespinsZeroBetPresentation()
    ];

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "FS intro runner");
    }
}